const umaKey = '67ce4afc65c707471a165fe6'

;(function (w, d, s, q, i) {
  w[q] = w[q] || []
  var f = d.getElementsByTagName(s)[0]
  var j = d.createElement(s)
  j.async = true
  j.id = 'beacon-aplus'
  j.src = 'https://d.alicdn.com/alilog/mlog/aplus/' + i + '.js'
  f.parentNode.insertBefore(j, f)
})(window, document, 'script', 'aplus_queue', '203467608')

//集成应用的appKey
aplus_queue.push({
  action: 'aplus.setMetaInfo',
  arguments: ['appKey', umaKey],
})

//sdk提供手动pv发送机制，启用手动pv(即关闭自动pv)，需设置aplus-waiting=MAN;
//注意：由于单页面路由改变时不会刷新页面，无法自动发送pv，所以对于单页应用，强烈建议您关闭自动PV, 手动控制PV事件
aplus_queue.push({
  action: 'aplus.setMetaInfo',
  arguments: ['aplus-waiting', 'MAN'],
})

//是否开启调试模式
aplus_queue.push({
  action: 'aplus.setMetaInfo',
  arguments: ['DEBUG', true],
})
console.log('aplus_queue', aplus_queue)

/**
 * @type {Object} umeng - 友盟统计工具对象
 */
const umeng = {
  /**
   * 发送页面访问统计
   * @param {string} path - 页面路径
   * @param {Object} params - 额外参数
   */
  sendPV (path, params = {}) {
    if (!umaKey) {
      return console.info('umaKey未配置')
    }
    if (!path) return console.info('缺少主要参数-页面名称或路径')
    console.log('sendPV-----', path, params)

    window.aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [
        {
          is_auto: false
        },
        { page_path: path, ...params }
      ]
    })
  },

  /**
   * 记录自定义事件
   * @param {string} name - 事件名称
   * @param {Object} params - 事件参数
   * @param {string} type - 事件类型
   */
  record (name, params = {}, type = 'CLK') {
    if (!umaKey) {
      return console.info('umaKey未配置')
    }
    if (!name) return console.info('缺少主要参数-自定义时间code')
    console.log('record-----', name, params, type)

    const aplusQueue = window.aplus_queue
    aplusQueue.push({
      action: 'aplus.record',
      arguments: [name, type, params]
    })
  }
}

export { umeng }
